import React from 'react'

import './articles.css'

const NewsAndArticles = (props) => {
  const { pages } = props
  return pages.map(({ image, title, createdAt, description, slug }) => (
    <div className='article' key={`${slug}-${createdAt}-${title}`}>
      <img src={image} width={193} height={273} alt={title} />
      <div className='article__content'>
        <div className='article__content__title'>{title}</div>
        <div className='article__content__date'>{new Date(createdAt).toLocaleDateString('uk-UA')}</div>
        <div className='article__content__description'>
          {description}
        </div>
        <a href={`/page/${slug}`}>
          <div className='article__content__more'>Детальніше</div>
        </a>
      </div>
    </div>
  ))
}

export default NewsAndArticles
